import React from 'react';
import DeliveryAPIError from 'components/contentstack/DeliveryAPIError';
import ErrorPage from 'components/contentstack/ErrorPage';
import ContentstackRenderer from 'components/contentstack/renderer';
import MetaDataComponent from 'components/SEO/MetaDataComponent';
import { useFormat } from 'helpers/hooks/useFormat';

const ContentstackCategoryLandingTastic = ({ data }: any) => {
  const { formatMessage } = useFormat({ name: 'categories' });
  const content = data?.data?.dataSource.payload[0] as any;
  if (!content) {
    return <ErrorPage />;
  } else if (content?.err) {
    return <DeliveryAPIError data={content.err} />;
  } else {
    const meta = content.data.meta_data ?? {};

    const metaData = {
      ...meta,
      meta_title: content?.data.category_slug.endsWith('/overview')
        ? formatMessage({
            id: 'overview.meta.title',
            defaultMessage: '{title} | Nikon USA',
            values: { title: content?.data.title || '' },
          })
        : formatMessage({
            id: 'meta.title',
            defaultMessage: 'Shop All Nikon {category} | Nikon USA',
            values: { category: content?.data.title || '' },
          }),
    };
    return (
      <>
        <MetaDataComponent content={metaData} tasticName="ContentstackCategoryLandingTastic" />
        <ContentstackRenderer data={content.data} contentTypeUid={content.contentTypeUid} />
      </>
    );
  }
};

export default ContentstackCategoryLandingTastic;
